
























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { DatePostProperties, FormatOptions, MomentFormat, FormatValue, CapitalizeEnum } from "@/services/posts/postTypes/date";
import { GetLocalizedLanguages, GetLocalizedDateFormats } from "@/components/posts/PostTypeRegister";
import { getTimeZones } from "@/services/timeZones/timeZoneService";
import { TimeZone } from "@/services/timeZones/types";
import moment from "moment";
import vSelect from "vue-select";
import validate from "@/directives/validate";
import { propertiesValidators } from "@/components/posts/date/validators";
import { validateForm } from "@/services/validation/validationService";
import { renderDate } from "./dateFormatting";
import i18n from "@/i18n";

@Component({
    components: {
        vSelect
    },
    directives: {
        validate
    }
})
export default class DateForm extends Vue {
    @Prop() private properties!: DatePostProperties;
    @Prop() defaultShowTime!: number;

    formatOptions = FormatOptions;
    validators = propertiesValidators;
    localPropertiesValue: DatePostProperties | null = null;
    timeZones: TimeZone[] = [];

    // watchers
    @Watch("defaultShowTime")
    onDefaultShowTimeChanged() {
        if (this.localProperties.showTime) return;
        this.$set(this.localProperties, "showTime", this.defaultShowTime);
    }

    // lifecycle hooks
    async created() {
        this.timeZones = await getTimeZones();
        const browserLocation = Intl.DateTimeFormat().resolvedOptions().timeZone.split("/")[1];
        const localUtcOffset = this.timeZones.find(x => x.displayName.includes(browserLocation));
        this.timeZones.unshift({
            id: "localtime",
            displayName: i18n.t("posts.date.timezones.localTime"),
            baseUtcOffset: localUtcOffset ? localUtcOffset.baseUtcOffset : moment().utcOffset.toString(),
            offset: localUtcOffset ? localUtcOffset.offset : moment().utcOffset.toString()
        } as TimeZone).toString();
        this.timeZones.unshift({
            id: "SolutionTimeZone",
            displayName: i18n.t("posts.date.timezones.solutionTimeZone"),
            baseUtcOffset: localUtcOffset ? localUtcOffset.baseUtcOffset : moment().utcOffset.toString(),
            offset: localUtcOffset ? localUtcOffset.offset : moment().utcOffset.toString()
        } as TimeZone).toString();
        // Check for undefined timezone and set local timezone.
        if (this.localProperties.timeZone === "") {
            this.localProperties.timeZone = this.timeZones[0].id;
        } else if (this.localProperties.timeZone === undefined) {
            this.localProperties.timeZone = this.timeZones[1].id;
            this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
        }
        if (this.properties.dateFormat) {
            this.momentFormat = this.properties.dateFormat;
        } else {
            this.localProperties.dateFormat = this.momentFormat;
            this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
        }
    }

    // computed
    get localProperties(): DatePostProperties {
        if (Object.keys(this.properties).length) {
            this.localPropertiesValue = JSON.parse(JSON.stringify(this.properties));
        } else if (this.localPropertiesValue === null) {
            this.localPropertiesValue = {
                language: "",
                format: "custom",
                dateFormat: {
                    dateOptionOne: { format: "", capitalize: CapitalizeEnum.Locale } as FormatValue,
                    dateOptionTwo: { format: "", capitalize: CapitalizeEnum.Locale } as FormatValue,
                    dateOptionThree: { format: "", capitalize: CapitalizeEnum.Locale } as FormatValue,
                    dateOptionFour: { format: "", capitalize: CapitalizeEnum.Locale } as FormatValue,
                    textOne: "",
                    textTwo: "",
                    textThree: "",
                    textFour: "",
                    textFive: ""
                },
                showTime: 1,
                timeZone: ""
            };
            this.$emit("setDefaultValues", JSON.stringify(this.localPropertiesValue));
        }
        return this.localPropertiesValue as DatePostProperties;
    }

    get momentFormat(): MomentFormat {
        return this.localProperties.dateFormat;
    }

    set momentFormat(value: MomentFormat) {
        this.localProperties.dateFormat = value;
    }

    get localizedLanguages() {
        return GetLocalizedLanguages();
    }

    get localizedDateFormats() {
        return GetLocalizedDateFormats();
    }

    get utcOffset() {
        const timezone = this.timeZones.find(x => x.id === this.localProperties.timeZone);
        const result = timezone
            ? timezone.offset.charAt(0) !== "-" ? "+".concat(timezone.offset)
                : timezone.offset
            : moment.parseZone(moment()).utcOffset().toString();
        return result;
    }

    get previewDate() {
        return renderDate(moment(), this.localProperties, this.utcOffset);
    }

    formatChange(format: string) {
        switch (format) {
        case "e-b":
            this.setFormat("", "-", "-", "", "", { format: "", capitalize: CapitalizeEnum.Locale }, { format: "DD", capitalize: CapitalizeEnum.Locale }, { format: "MM", capitalize: CapitalizeEnum.Locale }, { format: "YYYY", capitalize: CapitalizeEnum.Locale });
            break;
        case "e-us":
            this.setFormat("", "-", "-", "", "", { format: "", capitalize: CapitalizeEnum.Locale }, { format: "MM", capitalize: CapitalizeEnum.Locale }, { format: "DD", capitalize: CapitalizeEnum.Locale }, { format: "YYYY", capitalize: CapitalizeEnum.Locale });
            break;
        case "dk":
            this.setFormat("d.", ".", ".", "", "", { format: "", capitalize: CapitalizeEnum.Locale }, { format: "DD", capitalize: CapitalizeEnum.Locale }, { format: "MM", capitalize: CapitalizeEnum.Locale }, { format: "YYYY", capitalize: CapitalizeEnum.Locale });
            break;
        case "swed":
            this.setFormat("", ".", ".", "", "", { format: "", capitalize: CapitalizeEnum.Locale }, { format: "YYYY", capitalize: CapitalizeEnum.Locale }, { format: "MM", capitalize: CapitalizeEnum.Locale }, { format: "DD", capitalize: CapitalizeEnum.Locale });
            break;
        case "nor":
            this.setFormat("", ".", ".", "", "", { format: "", capitalize: CapitalizeEnum.Locale }, { format: "YYYY", capitalize: CapitalizeEnum.Locale }, { format: "MM", capitalize: CapitalizeEnum.Locale }, { format: "DD", capitalize: CapitalizeEnum.Locale });
            break;
        case "ger":
            this.setFormat("", ".", ".", "", "", { format: "", capitalize: CapitalizeEnum.Locale }, { format: "DD", capitalize: CapitalizeEnum.Locale }, { format: "MM", capitalize: CapitalizeEnum.Locale }, { format: "YYYY", capitalize: CapitalizeEnum.Locale });
            break;
        case "fr":
            this.setFormat("", "/", "/", "", "", { format: "", capitalize: CapitalizeEnum.Locale }, { format: "DD", capitalize: CapitalizeEnum.Locale }, { format: "MM", capitalize: CapitalizeEnum.Locale }, { format: "YYYY", capitalize: CapitalizeEnum.Locale });
            break;
        case "esp":
            this.setFormat("", "/", "/", "", "", { format: "", capitalize: CapitalizeEnum.Locale }, { format: "DD", capitalize: CapitalizeEnum.Locale }, { format: "MM", capitalize: CapitalizeEnum.Locale }, { format: "YYYY", capitalize: CapitalizeEnum.Locale });
            break;
        case "prt":
            this.setFormat("", "/", "/", "", "", { format: "", capitalize: CapitalizeEnum.Locale }, { format: "DD", capitalize: CapitalizeEnum.Locale }, { format: "MM", capitalize: CapitalizeEnum.Locale }, { format: "YYYY", capitalize: CapitalizeEnum.Locale });
            break;
        case "mex":
            this.setFormat("", "/", "/", "", "", { format: "", capitalize: CapitalizeEnum.Locale }, { format: "DD", capitalize: CapitalizeEnum.Locale }, { format: "MM", capitalize: CapitalizeEnum.Locale }, { format: "YYYY", capitalize: CapitalizeEnum.Locale });
            break;
        default:
            this.setFormat("", "", "", "", "", { format: "", capitalize: CapitalizeEnum.Locale }, { format: "", capitalize: CapitalizeEnum.Locale }, { format: "", capitalize: CapitalizeEnum.Locale }, { format: "", capitalize: CapitalizeEnum.Locale });
            break;
        }
        this.setItemName();
    }

    setFormat(second: string, third: string, fourth: string, prefix: string,
        sufix: string, firstOption: FormatValue, secondOption: FormatValue,
        thirdOption: FormatValue, fourthOption: FormatValue) {
        this.momentFormat.textTwo = second;
        this.momentFormat.textThree = third;
        this.momentFormat.textFour = fourth;
        this.momentFormat.textOne = prefix;
        this.momentFormat.textFive = sufix;
        this.momentFormat.dateOptionOne = firstOption;
        this.momentFormat.dateOptionTwo = secondOption;
        this.momentFormat.dateOptionThree = thirdOption;
        this.momentFormat.dateOptionFour = fourthOption;
    }

    setFormatToCustom() {
        this.localProperties.format = "custom";
        this.setItemName();
    }

    async validateData() {
        return await validateForm([this.validators]) && this.previewDate;
    }

    timeZoneChanged() {
        this.setItemName();
    }

    emitData() {
        this.localProperties.dateFormat = this.momentFormat;
        this.$emit("propertiesUpdated", this.localProperties);
    }

    setItemName() {
        var format = this.dateFormatString();
        const timezone = this.timeZones.find(x => x.id === this.localProperties.timeZone);
        var name = this.localProperties.timeZone === "localtime" ? format
            ? `${this.$i18n.t("posts.date.title")} ${format}` : ""
            : timezone ? `${this.$i18n.t("posts.date.title")} ${timezone ? timezone.displayName : ""}` : "";
        this.$emit("itemNameUpdated", name);
    }

    dateFormatString() {
        return `${this.localProperties.dateFormat.textOne}${this.localProperties.dateFormat.dateOptionOne.format}
            ${this.localProperties.dateFormat.textTwo}${this.localProperties.dateFormat.dateOptionTwo.format}
            ${this.localProperties.dateFormat.textThree}${this.localProperties.dateFormat.dateOptionThree.format}
            ${this.localProperties.dateFormat.textFour}${this.localProperties.dateFormat.dateOptionFour.format}
            ${this.localProperties.dateFormat.textFive}`.replace(/\s/g, "").trim();
    }
}
